import Vue from 'vue';
import VueGtm from 'vue-gtm';

Vue.use(VueGtm, {
    id: 'GTM-W5KCTB6',
    enabled: true,
    debug: process.env.NODE_ENV !== 'production',
    trackOnNextTick: true,
});
